import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-registration-alt-details-coupon-dialog',
    template: require('./registrationDialogAltDetailsCoupon.html')
})
export class RegistrationAltDetailsCouponDialog  {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationAltDetailsCouponDialog>) public dialogRef: MatDialogRef<RegistrationAltDetailsCouponDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
